import {RoleModel} from "../models/RoleModel";

export const ROLES:RoleModel[] = [
    {code: 0, name: 'Админ'},
    {code: 1, name: 'Клиент'},
    {code: 2, name: 'Исполнитель'},
]